import { Component } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { IconComponent } from '../../../../../../../../shared/components/ui/icon/icon.component';
import { TranslatePipe } from '../../../../../../../../shared/pipes/translate/translate.pipe';
import { AsyncPipe, NgClass } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { EditorModule } from '@progress/kendo-angular-editor';
import { UpdateDeleteState } from 'src/models/ts/update-delete-state.model';
import { CheckBoxModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ExamQuestionSignalr } from '../../../../../../../../../models/ts/exam-question-signalr';
import { ExamAnswerSignalr } from '../../../../../../../../../models/ts/exam-answer-signalr';

@Component({
  selector: 'bizz-exam-creator-add-question-control',
  standalone: true,
  imports: [
    IconComponent,
    TranslatePipe,
    NgClass,
    AsyncPipe,
    FormsModule,
    EditorModule,
    CheckBoxModule,
    NumericTextBoxModule,
    TooltipModule
  ],
  templateUrl: './exam-creator-add-question-control.component.html',
  styleUrl: './exam-creator-add-question-control.component.scss'
})
export class ExamCreatorAddQuestionControlComponent {
  public question$ = new BehaviorSubject<ExamQuestionSignalr>({} as ExamQuestionSignalr);
  public hasQuestionErrors = false;
  public hasAnswerErrors = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly UpdateDeleteState = UpdateDeleteState;

  public constructor(private dialogRef: DialogRef) {
    // setting value or init a new one for create
    this.question$.next(structuredClone(this.dialogRef.config.data) ?? { answers: [] });
  }

  public close(): void {
    this.dialogRef.close(undefined);
  }

  public saveQuestion(): void {
    if (this.validate()) {
      this.dialogRef.close(this.question$.value);
    }

  }

  public delete(index: number): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const found = this.question$.value;
    found.answers[index].state = UpdateDeleteState.Delete;
    this.question$.next(found);
  }

  public addAnswer(): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const found = this.question$.value;
    found.answers.push({ score: 0 } as ExamAnswerSignalr);
    this.question$.next(found);
  }

  public validate(): boolean {

    this.hasQuestionErrors = this.question$.value.caption == null || this.question$.value.caption == '';
    this.hasAnswerErrors = false;
    this.question$.value.answers
      .filter(el=> el.state != UpdateDeleteState.Delete) // dont validate deleted records (duh xD)
      .forEach((answer) => {
        if (answer.caption == null || answer.caption == '') {
          this.hasAnswerErrors = true;
        }
      }
    );
    if (this.question$.value.answers.filter(answers => answers.score > 0).length <= 0) {
      this.hasAnswerErrors = true;
    }
    return !this.hasQuestionErrors && !this.hasAnswerErrors;
  }

}
